/**
 * 校验身份证号
 * @param val 身份证号
 * @param isEmpty 是否可以为空
 * @returns true 校验成功
 */
export const validIdCard = (val: string, isEmpty?: boolean): boolean => {
  const regex =
    /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/;
  return isEmpty ? (!val ? true : regex.test(val)) : regex.test(val);
};

/**
 * 校验手机号码
 * @param val 手机号码
 * @param isEmpty 是否可以为空
 * @returns true 校验成功
 */
export const validPhone = (val: string, isEmpty?: boolean): boolean => {
  const regex = /^(?:(?:\+|00)86)?1\d{10}$/;
  return isEmpty ? (!val ? true : regex.test(val)) : regex.test(val);
};

/**
 * 校验车牌号
 * @param val 车牌号
 * @param isEmpty 是否可以为空
 * @returns true 校验成功
 */
export const validLicense = (val: string, isEmpty?: boolean): boolean => {
  const regex =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
  return isEmpty ? (!val ? true : regex.test(val)) : regex.test(val);
};
